/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Value data type
 */
export type DataType = (typeof DataType)[keyof typeof DataType];

export const DataType = {
  TEXT: 'text',
  BOOLEAN: 'boolean',
  INTEGER: 'integer',
  FLOAT: 'float',
} as const;
